// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Ln1m","title":"Header_title__2IFmx","left":"Header_left__oIbUs","clinicName":"Header_clinicName__2FPT1"};